<!-- 成绩设置 -->
<template>
    <div>
    <div class="title flex-row-center">
        <div>
            <span>第{{round}}轮 成绩设置</span><span class="red mg-l-10">{{errorMsg}}</span>
        </div>        
        <el-button style="font-size: 16px;" type="danger" @click="scoreConfirm" :disabled="disabled">本轮成绩确认</el-button>
    </div>  
    <el-row  :span="6" class="mg-b-10" >
        修改第  {{newRound}} 轮成绩
        <el-select v-model="newRound" placeholder="请选择轮数" @change="newUpDownRound" >
            <el-option 
                v-for="item in roundList"  
                :value="item.value"  
                :label="item.label" 
                :key="item.label">
            </el-option>
        </el-select>       
    </el-row>
    <div class="score-table custom-table2">
        <el-table :data="newTableData"  :row-class-name="tableRowClassName" 
        class="custom-table" style="width: 100%" border>
            <el-table-column prop="deskNo" label="桌号" align="center" width="80"/>
            <el-table-column prop="usernameWE" label="东西" align="center"/>
            <el-table-column prop="scoreWE" label="级数" align="center" width="90"/>       
            <el-table-column prop="usernameSN" label="南北" align="center" />     
            <el-table-column prop="scoreSN" label="级数" align="center" width="90"/>  
            <el-table-column prop="number" label="操作" width="180" align="center">
                <template slot-scope="scope">
                    <el-button @click="handleUpdateScore(scope.row)" type="text" size="medium">
                        {{ disabled?'修改成绩':'记录成绩' }}</el-button>
                    <el-button @click="handleDeleteScore(scope.row)" type="text" size="medium" v-if="!disabled">清除成绩</el-button>
                </template>
            </el-table-column>  
        </el-table>
    </div>  
    <div v-if="showPoker" class="score-wrap">
        <div class="mg-t-20 mg-b-10 size18">设置第{{ deskNo }}桌成绩</div>
        <div class="mg-t-20 mg-b-10"><span>东西</span>
            <span class="card-number-q" v-if="pubType === '2'"
            :class="porkWE ? 'isSelected': ''" @click="gameOverWE">弃</span>
            <span class="card-number-q" v-else
             @click="gameOver">弃</span>
        </div>
        <div class="card-pok">            
            <div class="card-number" :class="activeA === item.name ? 'isSelected': ''"  
            @click="seatWeatEast(item.name,item.index)"
             v-for="item in originPok" :key="item.name" >{{ item.name }}</div>
        </div>
        <div class="mg-t-20 mg-b-10"><span>南北</span>
            <span class="card-number-q" v-if="pubType === '2'"
            :class="porkSN ? 'isSelected': ''" @click="gameOverSN">弃</span></div>
        <div class="card-pok">           
            <div class="card-number" :class="activeB === item.name ? 'isSelected': ''"  
            @click="seatSouthNorth(item.name,item.index)"
            v-for="item in originPok" :key="item.name">{{ item.name }}</div>
        </div>
        <el-button class="mg-t-20" type="danger"  @click="updateScore" v-if="disabled">确认修改</el-button>
        <el-button class="mg-t-20" type="primary" @click="scoreSubmit" v-else>成绩确认</el-button>
        <el-button  @click="handleClose">取消</el-button>
    </div>
    <!-- <div class="confirm-btn">
        <el-button type="danger" @click="scoreConfirm" :disabled="disabled">本轮赛事所有成绩完成确认</el-button>
    </div> -->
<el-dialog
  title="确定弃权吗？请选择弃权方位"
  :visible.sync="showSeatScore"
  width="30%"
  :before-close="handleClose">
    <div class="seat-wrap">
        <el-checkbox-group v-model="checkList" @change="changeSingle" class="mg-lr-20">
            <el-checkbox label="东"></el-checkbox>
            <el-checkbox label="南"></el-checkbox>
            <el-checkbox label="西"></el-checkbox>
            <el-checkbox label="北"></el-checkbox>
        </el-checkbox-group>        
    </div>
    <span slot="footer" class="dialog-footer">
        <el-button @click="confirmGameCancel" type="primary">确认弃权</el-button>
        <el-button @click="handleCancel">取消</el-button>
    </span>       
</el-dialog>
<!-- 裁判清除成绩 -->
<el-dialog
  title="确定清除成绩吗?"
  :visible.sync="showRemoveScore"
  width="30%"
  :before-close="handleClose">
    <div class="seat-wrap">
        <el-radio-group v-model="gamesIdValue" class="mg-lr-20">
            <el-radio :label="0">清除所有把成绩</el-radio>
            <el-radio :label="111">清除当前把成绩</el-radio>
        </el-radio-group>
        <div></div>
        <div></div>
        <!-- <el-checkbox-group v-model="checkList" @change="changeSingle" class="mg-lr-20">
            <el-checkbox label="清除所有局成绩"></el-checkbox>
            <el-checkbox label="清除当前局成绩"></el-checkbox>        
        </el-checkbox-group>         -->
    </div>
    <span slot="footer" class="dialog-footer">
        <el-button @click="confirmRemoveScore" type="primary">确认</el-button>
        <el-button @click="handleCancel">取消</el-button>
    </span>       
</el-dialog>
</div>
 </template>
 
 <script>
import { mapState } from 'vuex'

 export default {
     props:{
        pubId: {
             type: String,
             default: ''
         },
        pubType: {
            type: String,
            default: ''
        }
     },
     data() {
         return {
            activeA: 0,
            activeB: 0,
            dataList: [],
            tableData: [],
            ready: false,
            originPok: [],
            deskNo: 1,
            playersId: 1,
            thingPoker: '',
            northSouthPoker: '',
            showPoker: false,
            gamesId: 0,
            tableDataSign: [],
            tableDataDouble: [],
            newTableData: [],
            porkWE: false,
            porkSN:false,
            errorMsg: '',
            checkList: [],
            eastScore: 2,
            southScore: 2,
            westScore: 2,
            northScore: 2,  
            showSeatScore: false,
            roundList:[
                {label:1,value:1},
                {label:2,value:2},
                {label:3,value:3},
                {label:4,value:4},
                {label:5,value:5},
                {label:6,value:6},
            ],
            newRound: null,
            disabled: false,
            showRemoveScore: false,
            gamesIdValue: 0,
            removeDeskNo: 0,
         }
     },
     created() {
        
     },
     mounted() {
        this.getPoker()
        // document.addEventListener('click',this.handleClickOutside)
     },
     computed:{
        ...mapState(['round'])
     },
     methods: {
        tableRowClassName({row, rowIndex}){
            // 一桌一种颜色
            if(row.deskNo % 2){
                return 'white-row'
            }else{
                return  'green-row'
            }
        },
         // 赛事成绩查询
         initData(){
             let params = {
                opcode: this.$code.ScoreQuery,
                i_serial_mark: this.pubId,
                i_round: this.round,
                i_games_id: 111,
                i_desk_no: 0,
             }
             this.$api.requestAPI(params).then(res =>{
                 if (res.IsSuccess) {
                    let result = res.Data.DataTable
                    this.disabled = false
                    this.newRound = null
                    if(result.length === 0){
                        this.errorMsg = '请到编排界面，点击编排按钮！'
                        this.newTableData = []
                    }else{
                        this.errorMsg = ''
                        if(this.pubType === '1'){
                            let arr =  result.map(item=>{
                            return {
                                gamesId: item['局数'],
                                deskNo: item['桌号'],
                                seat: item['座位'],
                                score: item['成绩'],
                                username: item['选手名称'],
                                round: item['轮数'],
                                playersId: item['选手编号'],
                            }
                        })
                        let newArr  = this.selectDeskNo(arr)
                        this.newTableData = newArr
                        // console.log('单人',newArr)
                        }else{
                            let arr =  result.map(item=>{
                                return {
                                    gamesId: item['局数'],
                                    deskNo: item['桌号'],
                                    seat: item['座位'],
                                    score: item['成绩'],
                                    username: item['选手名称'],
                                    round: item['轮数'],
                                    partner: item['搭档名称'],
                                    playersId: item['选手编号'],
                                }
                            })
                            let newArr  = this.selectDeskNo(arr)
                            this.newTableData = newArr
                            // console.log('双人',newArr)
                        }
                    }                    
                }else{
                    this.errorMsg = res.Message
                    this.newTableData = []
                }
             })       
         },  
         selectDeskNo(arr){
             let result = []
             arr.forEach(item => {
                 if(!result.some(i => i.deskNo === item.deskNo )){
                        let newArr = arr.filter(user => user.deskNo === item.deskNo)
                        let scoreW = (newArr.filter(i =>  i.seat.includes('东')))[0].score
                        let scoreE = (newArr.filter(i =>  i.seat.includes('西')))[0].score
                        let scoreS = (newArr.filter(i =>  i.seat.includes('南')))[0].score
                        let scoreN = (newArr.filter(i =>  i.seat.includes('北')))[0].score    
                        let scoreWE = ''
                        let scoreSN= ''
                        let usernameWE = ''
                        let usernameSN = ''
                        if(this.pubType === '1'){
                            usernameWE = (newArr.filter(i =>  i.seat.includes('东')))[0].username +'/'+ (newArr.filter(i =>  i.seat.includes('西')))[0].username
                            usernameSN = (newArr.filter(i =>  i.seat.includes('南')))[0].username +'/'+ (newArr.filter(i =>  i.seat.includes('北')))[0].username
                            if(scoreW === '弃' && scoreE === '弃')  {
                                scoreWE = scoreW
                            }else if(scoreW === '弃' && scoreE !== '弃'){
                                scoreWE = scoreE
                            }else if(scoreW !== '弃' && scoreE === '弃'){
                                scoreWE =  scoreW
                            }else if(scoreW !== '弃' && scoreE !== '弃'){
                                scoreWE = scoreW
                            } 
                            if(scoreS === '弃' && scoreN === '弃')  {
                                scoreSN = scoreS
                            }else if(scoreS === '弃' && scoreN !== '弃'){
                                scoreSN = scoreN
                            }else if(scoreS !== '弃' && scoreN === '弃'){
                                scoreSN =  scoreS
                            }else if(scoreS !== '弃' && scoreN !== '弃'){
                                scoreSN = scoreS
                            } 
                        }else{
                            usernameWE = (newArr.filter(i =>  i.seat.includes('东')))[0].username +'/'+ (newArr.filter(i =>  i.seat.includes('东')))[0].partner
                            usernameSN = (newArr.filter(i =>  i.seat.includes('北')))[0].username +'/'+ (newArr.filter(i =>  i.seat.includes('北')))[0].partner
                            scoreWE = (newArr.filter(i =>  i.seat.includes('东')))[0].score
                            scoreSN = (newArr.filter(i =>  i.seat.includes('北')))[0].score
                        }                       
                        result.push({
                            deskNo: item.deskNo,
                            scoreWE: scoreWE,
                            scoreSN: scoreSN,
                            usernameWE: usernameWE,
                            usernameSN: usernameSN,
                            // users: arr.filter(user => user.deskNo === item.deskNo)
                        })
                 }
             });
             return result
         },    
          // 查询某一桌的成绩
          getDeskNoScore(){
             let params = {
                opcode: this.$code.ScoreQuery,
                i_serial_mark: this.pubId,
                i_round: this.round,
                i_games_id: 111,
                i_desk_no: this.deskNo,
             }
             this.$api.requestAPI(params).then(res =>{
                 if (res.IsSuccess) {
                    let result = res.Data.DataTable
                       console.log(result)  
                    let arr = []
                    if(this.pubType === '1'){
                        arr =  result.map(item=>{
                            return {
                                gamesId: item['局数'],
                                deskNo: item['桌号'],
                                seat: item['座位'],
                                score: item['成绩'],
                                username: item['选手名称'],
                                round: item['轮数'],
                                playersId: item['选手编号'],
                            }
                        })
                    }else{
                        arr =  result.map(item=>{
                            return {
                                gamesId: item['局数'],
                                deskNo: item['桌号'],
                                seat: item['座位'],
                                score: item['成绩'],
                                username: item['选手名称'],
                                round: item['轮数'],
                                partner: item['搭档名称'],
                                playersId: item['选手编号'],
                            }
                        })
                    }
                   
                    // 过滤 取到局数111 回显到 东西南北分数
                    let seatEast = arr.filter(i=>i.gamesId === 111 && i.seat.includes('东'))
                    let seatSouth = arr.filter(i=>i.gamesId === 111 && i.seat.includes('南'))
                    
                    this.thingPoker = seatEast[0].score
                    this.northSouthPoker = seatSouth[0].score
                    this.activeA = this.thingPoker
                    this.activeB = this.northSouthPoker
                    console.log(this.thingPoker,this.northSouthPoker)
                 }
             })       
            },         
        //  本轮赛事完成
        completed(){
             let params = {
                opcode: this.$code.PubComplete,
                i_serial_mark: this.pubId,
                i_round: this.round
             }
             this.$api.requestAPI(params).then(res =>{
                 if (res.IsSuccess) {
                     let result = res.Data.DataTable
                                
                 }
             })       
         },     
        //  赛事排名查看
        getRankQuery(){
            let params = {
                opcode: this.$code.RankQuery,
                i_serial_mark: this.pubId,
             }
             this.$api.requestAPI(params).then(res =>{
                 if (res.IsSuccess) {
                     let result = res.Data.DataTable
                     this.tableData = result.map(item=>{                    
                        return{
                            id: item['选手编号'],
                            rank: item['名次'],
                            score: item['积分'],
                            levelNum: item['升级数'],
                            partnerScore: item['搭档总分'],
                            totalRank: item['级差总分'],
                            partnerRank: item['搭档总级差分'],
                            totalScore: item['累计分'],
                            winNum: item['胜轮次'],                            
                        }
                    })           
                 }
             })  
        },
        getPoker(){
            let params = {
                opcode: this.$code.SystemCode,
                v_parent_name: '',
                i_no: 25
            }
            this.$api._requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    let result = res.Data.DataTable
                    this.originPok = result.map(item=>{
                        return {
                            name: item['词条索引'],
                            index: item['中文描述']
                        }
                    })                     
                }
            })
        },   
        seatWeatEast(value,index){
            // console.log(value)
            this.activeA = value
            this.thingPoker = value   
            this.porkWE = false      
        },
        seatSouthNorth(value,index){
            // console.log(value)
            this.activeB = value
            this.northSouthPoker = value      
            this.porkSN = false    
        }, 
        // 选第几桌录入分数
        selectedDesk(value){
            this.deskNo = value
            this.thingPoker = ''
            this.northSouthPoker = ''
            this.activeA = 0
            this.activeB = 0
            this.initData()
        },
        setDeskScore(row, column, cell, event){
            // console.log(row.deskNo)
            // this.deskNo = row.deskNo
            // setTimeout(() => {
            //     this.getDeskNoScore()
            // }, 100);
        },
        // 管理员设置分数
        handleUpdateScore(row){
            this.checkList =  []
            this.deskNo = row.deskNo 
            this.thingPoker = row.scoreWE
            this.northSouthPoker = row.scoreSN
            this.activeA = this.thingPoker
            this.activeB = this.northSouthPoker
            this.showPoker = true
            this.porkWE = row.scoreWE==='弃'? true:false
            this.porkSN = row.scoreSN==='弃'? true:false
        },
        // 赛事成绩详情
        scoreDetail(){
            let params = {
                opcode: this.$code.RankScoreDetail,
                i_serial_mark: this.pubId
            }
            this.$api._requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    let result = res.Data.DataTable
                                       
                }
            })
        },
        // 赛事管理查询
        pubManage(){
            let params = {
                opcode: this.$code.PubManageQuery,
                v_theme: '黄浦区掼蛋邀请赛',
                start_date: 0,
                end_date: 0,
                pagesize: 10,
                page: 1,
            }
            this.$api._requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    let result = res.Data.DataTable                                       
                }
            })
        },
         // 本局赛事成绩提交 管理员提交
         scoreSubmit(){
            if(this.thingPoker === '' || this.northSouthPoker === ''){
                this.$message.error('请先选择选手分数！')
                return false
            }
            let params = {
                opcode: this.$code.ScoreRoundConfirm,
                i_serial_mark: this.pubId,
                i_players_number: '',
                i_round: this.round,
                i_desk_no: this.deskNo,
                thing_poker: this.thingPoker,
                northsouth_poker: this.northSouthPoker,
             }
            //  console.log(params)
             this.$api.requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    this.$message.success(res.Message)     
                    this.initData()    
                    this.showPoker = false  
                }else{
                    this.$message.error(res.Message)  
                }
             })       
         }, 
        // 本轮赛事成绩确认
        scoreConfirm(){
            this.$confirm('确认每一桌成绩都设置完成，再进行成绩完成确认！','提示',{
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                
            }).then(()=>{
                let params = {
                    opcode: this.$code.PubComplete,
                    i_serial_mark: this.pubId,
                    i_round: this.round,
                }
                // console.log(params)
                this.$api.requestAPI(params).then(res=>{
                    if(res.IsSuccess){
                        this.$message.success('请到成绩查询中查看')      
                        this.saveRank()
                    }else{
                        this.$message.error(res.Message)
                    }
                })
            }).catch((err)=>{
                console.log(err)
            })             
        },
        // 管理员删除选手每一轮的成绩
        handleDeleteScore(row){
            this.showRemoveScore = true
            this.removeDeskNo = row.deskNo
            // this.$confirm(`确认清除第${row.deskNo}桌的成绩吗?`,'提示',{
            //     confirmButtonText: '确定',
            //     cancelButtonText: '取消',
            //     type: 'warning'
                
            // }).then(()=>{
            //     let params = {
            //         opcode: this.$code.ScoreDeleteRound,
            //         i_serial_mark: this.pubId,
            //         i_round: this.round,
            //         i_games_id: 0,
            //         i_desk_no: row.deskNo
            //     }
            //     // console.log(params)
            //     this.$api.requestAPI(params).then(res=>{
            //         if(res.IsSuccess){
            //             this.$message.success('删除成功')      
            //             this.initData()
            //         }else{
            //             this.$message.error(res.Message)
            //         }
            //     })
            // }).catch((err)=>{
            //     console.log(err)
            // }) 
        },
        confirmRemoveScore(){
            let params = {
                opcode: this.$code.ScoreDeleteRound,
                i_serial_mark: this.pubId,
                i_round: this.round,
                i_games_id: this.gamesIdValue,
                i_desk_no: this.removeDeskNo
            }
            console.log(params)
            this.$api.requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    this.$message.success('删除成功')      
                    this.initData()
                    this.showRemoveScore = false
                    this.gamesIdValue = 0
                }else{
                    this.$message.error(res.Message)
                }
            })
        },
        // 赛事排名保存
        saveRank(){
            let params = {
                opcode: this.$code.SaveRank,
                i_serial_mark: this.pubId,
             }
             this.$api.requestAPI(params).then(res =>{
                 if (res.IsSuccess) {
                    // this.$message.success('保存成功')
                    // this.errorMessage = ''
                 }else{
                    // this.errorMessage = res.Message
                    // this.$message.error(res.Message)
                 }
             })  
        },  
        gameOverWE(){
            this.porkWE = !this.porkWE      
            if(this.porkWE){
                if(this.porkSN && this.porkWE){
                    console.log('2')
                    this.northSouthPoker = '弃'
                    this.thingPoker = '弃'
                    this.activeA = 0
                    this.activeB = 0
                }else{
                    this.northSouthPoker = '6'
                    this.thingPoker =  '弃'
                    this.activeB = '6'
                    this.activeA = 0
                }
            }else{
                if(this.porkSN){
                    this.thingPoker = '6'
                    this.activeA = '6'
                    this.activeB = 0
                }else{
                    this.thingPoker = ''
                    this.activeA = 0
                    this.activeB = 0
                }
            }      
        },
        gameOverSN(){
            this.porkSN = !this.porkSN  
            if(this.porkSN){               
                if(this.porkSN && this.porkWE){
                    console.log('3')
                    this.northSouthPoker = '弃'
                    this.thingPoker = '弃'
                    this.activeA = 0
                    this.activeB = 0
                }else{
                    this.northSouthPoker = '弃'
                    this.thingPoker = '6'
                    this.activeB = 0
                    this.activeA = '6'
                }
            }else{
                if(this.porkWE){
                    this.northSouthPoker = '6'
                    this.activeA = 0
                    this.activeB = '6'
                }else{
                    this.northSouthPoker = ''
                    this.activeA = 0
                    this.activeB = 0
                }                
            }                
        },
        gameOver(){
            this.showSeatScore = true
            // console.log('第几轮',this.newRound)
            
        },
        changeSingle(value){
            if(value.length > 0){
                this.eastScore =  value.includes('东')?'弃':'6'
                this.southScore =  value.includes('南')?'弃':'6'
                this.westScore =  value.includes('西')?'弃':'6'
                this.northScore =  value.includes('北')?'弃':'6'
            }
        },
        confirmGameCancel(){
            let round = this.disabled ? this.newRound : this.round
            let params = {
                opcode: this.$code.SingelGameOver,
                i_serial_mark: this.pubId,
                i_round: round,
                i_desk_no: this.deskNo,
                i_players_number: 0,
                east_poker: this.eastScore,
                south_poker: this.southScore,
                west_poker: this.westScore,
                north_poker: this.northScore,
            }
            this.$api.requestAPI(params).then(res =>{
                if(res.IsSuccess){
                    this.showSeatScore = false;
                    this.checkList = []
                    this.showPoker = false
                    this.initData()
                }
            })
        },
        handleClickOutside(event){
            // console.log(event.target)          
            if (!event.target.closest('button')) {
                // 执行你想在点击按钮以外的地方时执行的操作
                console.log('点击了页面以外的区域');
                this.showPoker = false
                this.thingPoker = ''
                this.northSouthPoker = ''
            }
        },
        handleClose(){
            this.showPoker = false
            this.thingPoker = ''
            this.northSouthPoker = ''
        },
        handleCancel(){
            this.showSeatScore = false;
            this.checkList = []
            this.showRemoveScore = false
        },
        getRoundQuery(){
            let params = {
                opcode: this.$code.ScoreQuery,
                i_serial_mark: this.pubId,
                i_round: this.newRound,
                i_games_id: 111,
                i_desk_no: 0,
             }
             this.$api.requestAPI(params).then(res =>{
                 if (res.IsSuccess) {
                    let result = res.Data.DataTable
                    if(result.length === 0){
                        this.errorMsg = '请到编排界面，点击编排按钮！'
                        this.newTableData = []
                    }else{
                        this.errorMsg = ''
                        if(this.pubType === '1'){
                            let arr =  result.map(item=>{
                            return {
                                gamesId: item['局数'],
                                deskNo: item['桌号'],
                                seat: item['座位'],
                                score: item['成绩'],
                                username: item['选手名称'],
                                round: item['轮数'],
                                playersId: item['选手编号'],
                            }
                        })
                        let newArr  = this.selectDeskNo(arr)
                        this.newTableData = newArr
                        // console.log('单人',newArr)
                        }else{
                            let arr =  result.map(item=>{
                                return {
                                    gamesId: item['局数'],
                                    deskNo: item['桌号'],
                                    seat: item['座位'],
                                    score: item['成绩'],
                                    username: item['选手名称'],
                                    round: item['轮数'],
                                    partner: item['搭档名称'],
                                    playersId: item['选手编号'],
                                }
                            })
                            let newArr  = this.selectDeskNo(arr)
                            this.newTableData = newArr
                            // console.log('双人',newArr)
                        }
                    }                    
                }else{
                    this.errorMsg = res.Message
                    this.newTableData = []
                }
             })       
         },
        newUpDownRound(){             
            if(this.newRound > this.round){
                this.disabled = false
                this.$message.error("暂无这一轮成绩")
                this.newTableData = []
            }else{
                this.disabled = true                
                this.getRoundQuery()
            }
            if(this.newRound == this.round){
                this.disabled = false
            }
        },
        updateScore(){
            if(this.thingPoker === '' || this.northSouthPoker === ''){
                this.$message.error('请先选择选手分数！')
                return false
            }
            let params = {
                opcode: this.$code.UpdateScore,
                i_serial_mark: this.pubId,
                i_round: this.newRound,
                i_desk_no: this.deskNo,
                thing_poker: this.thingPoker,
                northsouth_poker: this.northSouthPoker
            }
            this.$api.requestAPI(params).then(res =>{
                 if (res.IsSuccess) {                    
                    this.$message.success("修改成功")
                    this.getRoundQuery()
                    this.showPoker = false
                 }else{
                    this.$message.error(res.Message)
                 }
            })
        },
     },
     destroyed() {
        document.removeEventListener('click', this.handleClickOutside);
     },
 }
 </script>
 <style lang='scss' scoped>
 @import '@/assets/css/style.scss';
 .title{
     font-size: 28px;
     margin-bottom: 10px;
 }
 .custom-table >>> .el-table__header-wrapper tr th{
    font-size: 20px;
    color: #000;
}
 .el-table >>> .green-row{
    background-color: #bbffbb
  }
  .el-table >>> .white-row{
    background-color: #f0f9eb;
  }
 table {
     width: 100%;
     border-collapse: collapse;
   }
   th, td {
     border: 1px solid #999;
     padding: 8px;
     text-align: left;
     font-size: 28px;
   }
   tr:nth-child(even) {
     background-color: lightblue;
   }
   thead th {
     background-color: #f2f2f2;
     font-size: 30px;
     text-align: center;
   }
   .table-label {
     display: flex;
     justify-content: space-between;
     align-items: center;
     padding: 10px;
     background-color: #f9f9f9;
     border: 1px solid #ddd;
   }
   .custom-table >>> .el-table__header-wrapper tr th{
    font-size: 18px;
    color: #333;
}
.card-number-q{  
    padding: 6px 10px;
    border-radius: 50%;
    color:#fff;
    cursor: pointer;
    margin-left: 14px;
    text-align: center;
    font-weight: bold;
    border: 1px solid #eee;
    background-color: red;
  }
  .card-number-q:hover{
    background-color: #f99f43;
  }
.card-number{    
    width: 40px;
    height: 40px;
    line-height: 40px;
    border-radius: 50%;
    color:#fff;
    cursor: pointer;
    margin-right: 4px;
    text-align: center;
    font-weight: bold;
    border: 1px solid #eee;
    background-color: #3bcdf1;
  }
  .card-number:hover{
    background-color: #f99f43;
  }
  .isSelected{
    background-color: #ffcc00;
  }
  .card-pok{
    display: flex;
    flex-wrap: wrap;
  }
  .confirm-btn{
    margin-top: 20px;
    text-align: right;
  }
  .mg-l-10{
    margin-left: 10px;
  }
  .seat-wrap{
    padding: 10px 30px;
    background-color: #fff;
  }
  .score-wrap{
    padding: 10px 30px;
    background-color: #fff;
    position: fixed;
    top: 30%;
    left: 45%;
    z-index: 2;
    border: 1px solid #e1e1e1;
    border-radius: 10px;
  }
  .mg-lr-20{
    margin: 0 20rpx;
  }
.custom-table2 .el-table__cell {
    padding: 0 !important;
}
 </style>


// WEBPACK FOOTER //
// src/views/setting/components/setScore.vue